import React, { useState, useEffect, Fragment } from "react";

import {
  IonCard,
  IonCardContent,
  IonButton,
  IonAvatar,
  IonIcon,
  IonAlert,
  IonModal,
} from "@ionic/react";
import { useTranslation } from "react-i18next";

import "./doctor-card.scss";
import Call from "../../../Call/call";
import Sms from "../../../Sms/sms";
import FileShare from "../../../FileShare/fileShare";
import {
  DeleteCardParams,
  DoctorDataModel,
  ShiftTime,
} from "./doctor-card.model";
import {
  doctorListInputData,
  doctorListParams,
  doctorListResultInterface,
} from "../../doctor-list.model";
import { CONSTANTS } from "../../../../../constants";
import { doctorCardService } from "../DoctorCard/doctor-card-service";
import { RolePermissionData } from "../../../../../models";
import {
  chatboxEllipses,
  checkmarkCircleSharp,
  close,
  closeCircleSharp,
  closeOutline,
  removeCircleSharp,
} from "ionicons/icons";
import { utilService } from "../../../../../services/utilService";
import { toNumber } from "lodash";
import { sBoardProviderService } from "../../../../../pages/StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider.service";
import _ from "lodash";
import { statusBoardSocketService } from "../../../../../pages/StatusBoard/StatusBoardSocketService";

import TeamsPage from "../../../../../pages/Teams/teams";
import { useToast } from "@agney/ir-toast";
import TeamCreation from "../../../TeamsCreationModal/TeamCreationModal";
import TeammatesToProvider from "../../../TeammatesToProvider/TeammatesToProvider";
import { teamsListService } from "../../../../../pages/Teams/teams.service";
import { rolePermissionsService } from "../../../../../services/rolePermissions.service";
import { EMSAlertService } from "../../../../../services/EMSAlert.service";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { useNetwork } from "../../../../../helpers/NetworkContext";
import { loggedInUserService } from "../../../../../services/loggedInUser.service";

interface doctorCardParams {
  isFromGlobalTeamAccordion?: boolean;
  getSelectedCards: (doctorCard: DoctorDataModel) => void;
  doctorData: any;
  doctorListInputDetails: doctorListInputData;
  rolePermissions: RolePermissionData;
  hideFeatureButtons?: boolean;
  apiParameters?: doctorListParams;
  numberBadge?: any;
  isFromTeams?: any;
  updateTeamList?: any;
  isFromUserCard?: any;
  teamID?: any;
  teamDetails?: any;
  isFromCaseHistoryDetails?: any;
  patientID?: any;
  emsAddProvider?: any;
  updateCaseDetailsPage?: any;
  patientDataID?: any;
  caseDetailsPageProviderList?: any;
  isFromCareTeamCard?: any;
  isFromOnCallSearch?: any;
  isCancelledOrCancelled?: any;
  patientData?: any;
  isFromSpecialitySearch?: any;
}

const DoctorCard: React.FC<doctorCardParams> = (props) => {
  const history = useHistory();
  const { selectedNetwork } = useNetwork();
  const { t } = useTranslation("home");
  const [checked, showShiftData] = useState(false);
  const [showOnlineBadge, setShowOnlineBadge] = useState(false);
  const [hideMoreButton, setHideMoreButton] = useState(false);
  const [hideLessButton, setHideLessButton] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isShowUnlinkAlert, SetIsShowUnlinkAlert] = useState(false);
  const [isShowUnlinkProviderAlert, SetIsShowUnlinkProviderAlert] =
    useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [itemToDelete, setItemToDelete]: any = useState();
  const [editTimeModal, enableEditTimeModal] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState();
  const [showTeammatesToProviderModal, setTeammatesToProvider] =
    useState(false);
  const [otherUserList, setOtherUserList]: any = useState({});
  const [showStatusMessage, setShowStatusMessage]: any = useState(false);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [statusMessage, setStatusMessage] = useState<string>("");
  const [teamListData, setTeamListData]: any = useState();
  const [profilePicData, setMapProfilePicData]: any = useState("");
  const Toast = useToast();
  const componentName: string = props.doctorListInputDetails.componentName;
  const [isOnUSer,setIsOnUSer] = useState(false)

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setIsOnUSer(data?.userData?.roleBasedPermission?.isOnUser)
    });
    return () => subscription.unsubscribe();
  }, [])
  useEffect(() => {
    if (!_.isEmpty(props.doctorData)) {
      doctorCardService.setInitialDoctorCardHeight(props.doctorData);
      if (props.doctorListInputDetails.isShowColorBadge) {
        doctorCardService.setDoctorBadgeColor(props.doctorData);
      }
      setShowOnlineBadge(
        doctorCardService.showOnlineBadge(props.doctorData, componentName)
      );
      doctorCardService.alignMoreButton(props.doctorData);
    }
  }, [props.doctorData]);

  useEffect(() => {
    if (checked) {
      doctorCardService.alignLessButton(props.doctorData);
    } else {
      doctorCardService.alignMoreButton(props.doctorData);
    }
  }, [checked]);

  useEffect(() => {
    getTeammatesList();
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);
  useEffect(() => {
    if (showStatusMessage) {
      setShowStatusMessage(showStatusMessage);
    }
  }, [showStatusMessage]);

  useEffect(() => {
    profilePicFormatinTeams();
  }, [props.doctorData]);

  const profilePicFormatinTeams = async () => {
    
    if (props.isFromGlobalTeamAccordion) {
      teamMatesListArr(props.doctorData);

      if (!_.isEmpty(props.doctorData.profile_pic)) {
        if (
          !props.doctorData.profile_pic.includes("://thecallcentral.com") &&
          !props.doctorData.profile_pic.includes(
            "assets/images/defaultProfilePic.png"
          )
        ) {
          props.doctorData.profile_pic =
             props.doctorData.profile_pic;
        }
      } else {
        props.doctorData.profile_pic = "assets/images/defaultProfilePic.png";
      }
      setMapProfilePicData(props.doctorData.profile_pic);
      return props.doctorData.profile_pic;
    }
  };

  const getTeammatesList = async () => {
    let params: any = {
      user_guid: props.doctorData
        ? props.doctorData.guid
        : utilService.getLoggedUserGuid(),
    };
    const respTeammatesList = await teamsListService.getTeammatesListData(
      params
    );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      setOtherUserList(respTeammatesList!.result!.otherUserList);
    }
  };

  async function removeCardItemOnClick() {
    const params: DeleteCardParams = getRemoveCardApiParams();
    const respDoctorListResult: doctorListResultInterface =
      await doctorCardService.removeCardItemFromList(params);
    if (respDoctorListResult.isSuccess) {
      doctorCardService.removeCurrentCardItem(props.doctorData);
      sBoardProviderService.setDoctorListDataFromComponent(
        respDoctorListResult.doctorListResult
      );
      sBoardProviderService.updateDoctorList(
        respDoctorListResult.doctorListResult
      );
      const socketParams = {
        type: "providers",
      };
      statusBoardSocketService.sendSbInputSocketParams(socketParams);
      Toast.success("Proivder removed successfully");
    } else {
      doctorCardService.handleErrorResponse();
    }
  }

  const mapProfilePicData = (profilePic: string) => {
    if (!_.isEmpty(profilePic)) {
      if (
        !profilePic.includes("://thecallcentral.com") &&
        !profilePic.includes("assets/images/defaultProfilePic.png")
      ) {
        profilePic = utilService.getBaseUrl() + profilePic;
      }
    } else {
      profilePic = "assets/images/defaultProfilePic.png";
    }
    return profilePic;
  };

  const teamMatesListArr = (object: any): any => {
    let teammatesList = {
      addedToFavorite: object.added_to_favorite,
      alternateNumber: object.alternate_number,
      canEditTeamDatetime: object.can_edit_team_datetime,
      color: object.color,
      contactPreference: object.contact_preference,
      countryCode: object.country_code,
      designation: object.designation,
      displayName: object.display_name,
      email: object.email,
      firstName: object.first_name,
      groups: object.groups,
      guid: object.guid,
      id: object.id,
      image: object.image,
      isSelected: object.isSelected,
      isTeamAdmin: object.is_team_admin,
      lastName: object.last_name,
      mobileNumber: object.mobile_number,
      numberBadge: object.numberBadge,
      onGoing: object.onGoing,
      pager: object.pager,
      profilePic: mapProfilePicData(object.profile_pic),
      profile_status_message: object.profile_status_message,
      roles: object.roles,
      scheduleNames: object.schedule_names,
      shiftTime: object.shift_time,
      speciality: object.speciality,
      statusMessageAvailable: object.status_message_available,
      teamExpiryDate: object.team_expiry_date,
      teamExpiryTime: object.team_expiry_time,
      teamStartDate: object.team_start_date,
      teamStartTime: object.team_start_time,
      teamUnlink: object.team_unlink,
      teamsAvailable: object.teams_available,
      templateAvailability: object.template_availability,
      unavailableWhenNotOncall: object.unavailable_when_not_oncall,
      unlinkTill: object.unlink_till,
      username: object.username,
    };
    setTeamListData(teammatesList);
    return teammatesList;
  };

  const getRemoveCardApiParams = () => {
    var bedId: number = 0;
    if (props.apiParameters?.bedId) {
      bedId = toNumber(props.apiParameters.bedId);
    }
    return {
      bedId: bedId,
      remove_guid: props.doctorData.guid,
      hour: utilService.getCurrentHour(),
      minute: utilService.getCurrentMinutes(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
    };
  };

  const mapSpecialityDetails = (speciality: any) => {
    if (!_.isEmpty(speciality)) {
      return speciality.toString();
    } else {
      return "";
    }
  };


  const viewTeammates = () => {
    setIsShowModal(true);
  };

  const addTeammatesToProviders = () => {
    setTeammatesToProvider(true);
  };

  const getUserStatusMessage = async (selectedUserGuid: any,selectedNetwork?:any) => {
    const params = {
      guid: selectedUserGuid,
    };
    const apiResponse: any = await doctorCardService.getUserStatusMessage(
      params,selectedNetwork?.value??''
    );
    if (apiResponse.isSuccess) {
      let userMessage =
        apiResponse.result?.[0]?.profile_status_message.status_message;
      setStatusMessage(userMessage);
    }
  };

  const unlinkProviderFromCase = async () => {
    const params = getUnlinkProviderApiParams();
    const apiResponse: any = await doctorCardService.unlinkProviderFromCase(
      params
    );
    if (apiResponse.isSuccess) {
      Toast.success("Selected provider is successfully removed");
      props.updateCaseDetailsPage(props.patientDataID);
    }
  };

  const getUnlinkProviderApiParams = () => {
    return {
      emergency_provider_id: props.doctorData.emergencyProviderId,
      user_guid: utilService.getLoggedUserGuid(),
      reg_code: utilService.getNetwork(),
    };
  };

  const unlinkUserFromTeam = async () => {
    const params = getUnlinkUserApiParams();
    const apiResponse: any = await doctorCardService.unlinkUserFromTeamList(
      params
    );
    if (apiResponse.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.UNLINK_USER);
      props.updateTeamList(apiResponse.isSuccess);
    }
  };

  const getUnlinkUserApiParams = () => {
    return {
      reg_code: utilService.getNetwork(),
      user_guid: utilService.getLoggedUserGuid(),
      unlink_user_guid: itemToDelete,
      team_id: props.teamID,
    };
  };

  const editTimeSpanModal = (selectedUserData: any) => {
    enableEditTimeModal(true);
    setSelectedUserData(selectedUserData);
  };

  const updatedTeamList = (isSuccess: any) => {
    if (isSuccess) {
      props.updateTeamList(isSuccess);
    }
  };

  let hideSpeciality = false;

  return (
    <>
      <div>
        <IonModal
          isOpen={showStatusMessage}
          backdropDismiss={false}
          className="user-card-status-message-modal"
        >
          <div className="label-div">
            <div className="label-name">{t("statusMessage")}</div>
            <div
              className="input-icon icon-close"
              onClick={() => {
                setShowStatusMessage(false);
              }}
            ></div>
          </div>

          <div className="user-status-msg-container"> {statusMessage}</div>
        </IonModal>
        <IonAlert
          isOpen={isShowAlert}
          onDidDismiss={() => setIsShowAlert(false)}
          cssClass="doctor-card-alert"
          header={t("confirmation")}
          message={CONSTANTS.MESSAGES.REMOVE_CARD_CONFIRMATION}
          buttons={[
            {
              text: t("no"),
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: t("yes"),
              handler: () => {
                removeCardItemOnClick();
                setIsShowAlert(false);
              },
            },
          ]}
        />
        <IonCard
          className={`ion-card-wrapper ${
            props.doctorData.isTeamAdmin ? "team-admin-highlight" : ""
          }`}
        >
          <>
            <div
              id={`doctor-card-${props.doctorData.guid}`}
              className={`doctor-card ${
                props.isFromSpecialitySearch
                  ? "inactive-doctor-card"
                  : props.doctorData.isSelected
                  ? "active-doctor-card"
                  : ""
              } ${
                props.doctorData.providerAddedBy
                  ? "adjust-doctor-card-height"
                  : ""
              }
            ${
              props.isFromCareTeamCard
                ? "adjust-doctor-card-height-care-team"
                : ""
            }
                care-team-border-${props.doctorData.careTeamAlertStatus}
            ${
              props.doctorData.templateAvailability && !props.doctorData.onGoing
                ? "adjust-doctor-card-height-not-on-call"
                : ""
            }
                provider-${props.doctorData.providerAlertStatus}`}
              onClick={(e) => {
                e.stopPropagation();

                props.getSelectedCards(props.doctorData);
              }}
            >
              {props.doctorData.providerAddedBy && (
                <div
                  className="delete-provider"
                  onClick={() => {
                    SetIsShowUnlinkProviderAlert(true);
                  }}
                >
                  <IonIcon
                    class="close-icon-provider"
                    icon={closeOutline}
                  ></IonIcon>
                </div>
              )}
              <div className="doctor-card-wrapper">
                <div className="doctor-number-badge" hidden={props.isFromTeams}>
                  {props.numberBadge}
                </div>
                {/* A provider with no team expiry rendered the literal text
                    "End: Invalid Date 12:00 AM" -- dayjs(undefined) formats to
                    "Invalid Date", and the time came from a hardcoded
                    08-06-2024 plus a possibly-absent time. Show it only when
                    there is a date to show. */}
                <div
                  className="expiry-time-alert"
                  hidden={
                    !props.isFromTeams ||
                    !dayjs(props?.doctorData?.teamExpiryDate).isValid()
                  }
                >
                  {dayjs(props?.doctorData?.teamExpiryDate).isValid()
                    ? `End: ${dayjs(props.doctorData.teamExpiryDate).format("MM-DD-YY")}${
                        props?.doctorData?.teamExpiryTime
                          ? ` ${dayjs(
                              `1970-01-01 ${props.doctorData.teamExpiryTime}`
                            ).format("hh:mm A")}`
                          : ""
                      }`
                    : ""}
                </div>
                {!props.doctorListInputDetails.isHideProfilePic && (
                  <div className="profile-pic-div">
                    <IonAvatar className="doctor-profile-div">
                      <img
                        src={
                          props.isFromGlobalTeamAccordion
                            ? profilePicData
                            : props.doctorData.profilePic
                        }
                        alt="Ionic logo"
                        className="doctor-profile-image"
                        onError={(
                          e: React.SyntheticEvent<HTMLImageElement, Event>
                        ) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "assets/images/defaultProfilePic.png";
                        }}
                      />
                      {props.doctorListInputDetails.componentName !==
                      "OnCallLookUp" ? (
                        <div className="show-badge">
                          {showOnlineBadge && props!.doctorData.onGoing && (
                            <div className="online-icon-div" title={t("oncall")}>
                              <IonIcon icon={checkmarkCircleSharp} />
                            </div>
                          )}
                          {showOnlineBadge &&
                            !_.isEmpty(props.doctorData.templateAvailability) &&
                            !props.doctorData.onGoing && (
                              <div
                                className="template-availablity-icon-div"
                                title={t("availableNotOnCall")}
                              >
                                <IonIcon icon={removeCircleSharp} />
                              </div>
                            )}
                          {showOnlineBadge &&
                            !props.doctorData.onGoing &&
                            _.isEmpty(
                              props.doctorData.templateAvailability
                            ) && (
                              <div
                                className="not-on-going-div"
                                title={t("notOnCall")}
                              >
                                <IonIcon icon={closeCircleSharp} />
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="show-badge">
                          {showOnlineBadge && props?.doctorData?.onGoing && (
                            <div className="online-icon-div" title={t("oncall")}>
                              <IonIcon icon={checkmarkCircleSharp} />
                            </div>
                          )}
                          {showOnlineBadge &&
                            !props?.doctorData?.onGoing &&
                            props?.doctorData?.availableWhenNotOncall && (
                              <div
                                className="template-availablity-icon-div"
                                title={t("availableNotOnCall")}
                              >
                                <IonIcon icon={removeCircleSharp} />
                              </div>
                            )}
                          {showOnlineBadge &&
                            !props?.doctorData?.onGoing &&
                            !props?.doctorData?.availableWhenNotOncall && (
                              <div
                                className="not-on-going-div"
                                title={t("notOnCall")}
                              >
                                <IonIcon icon={closeCircleSharp} />
                              </div>
                            )}
                        </div>
                      )}
                    </IonAvatar>
                  </div>
                )}

                <div
                  className={`doctor-details ${
                    props.doctorListInputDetails.isHideProfilePic
                      ? "align-to-start"
                      : ""
                  } ${
                    props.doctorListInputDetails.componentName ===
                    CONSTANTS.COMPONENTS.GROUP_SMS
                      ? "details-width"
                      : ""
                  }${
                    props.hideFeatureButtons &&
                    "details-width-no-feature-buttons"
                  }`}
                >
                  <div
                    id={`doctor-details-div-${props.doctorData.guid}`}
                    className="doctor-details-div"
                  >
                    {props.doctorListInputDetails.isShowColorBadge && (
                      <div
                        id={`doctor-color-badge-${props.doctorData.guid}`}
                        className="dot-circle"
                      ></div>
                    )}
                    <div className="doctor-name">
                      {props?.isFromGlobalTeamAccordion ? (
                        <div className="doctor-name-label">
                          {props.doctorData.first_name}{" "}
                          {props.doctorData.last_name}
                        </div>
                      ) : (
                        <div className="doctor-name-label">
                          {props.doctorData.firstName}{" "}
                          {props.doctorData.lastName}
                        </div>
                      )}
                    </div>
                  </div>
                  {isOnUSer&&<div className="on-site-names">
                    <div className="doctor-name-label" style={{color:"var(--font-color-secondary) !important"}}>
                      {props.doctorData.sites?.join(", ")}
                    </div>
                  </div>}
                  {_.isEmpty(props.doctorData.shiftTime) && (
                    <>
                      <div className="no-shift-speciality-details">
                        <p>
                          {_.isEmpty(props.doctorData.speciality)
                            ? t("noSpeciality")
                            : mapSpecialityDetails(props.doctorData.speciality)}
                        </p>
                      </div>
                      <div>
                        {!_.isEmpty(props.doctorData.templateAvailability) ? (
                          componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                            <div className="not-oncall-div">
                              {!props.doctorData.onGoing &&
                                componentName ===
                                  CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                  <div>{t("notOnCall")}</div>
                                )}
                            </div>,
                            <div
                              className={`availability-div ${
                                _.isEmpty(props.doctorData.shiftTime) &&
                                "availability-div-no-shift"
                              }`}
                            >
                              {t("availableAt")} {" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.startTime
                              )}{" "}
                              --{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.endTime
                              )}
                            </div>,
                          ]
                        ) : (
                          <div className="availability-div-none"> -- </div>
                        )}
                      </div>
                    </>
                  )}

                  {!isOnUSer&&(props.doctorData?.shiftTime?.length > 0 ? (
                    <div>
                      <div>
                        <div className="speciality-details">
                          <div>
                            {doctorCardService.specialityTrim(
                              props.doctorData.shiftTime[0].group.speciality
                            )}
                          </div>
                        </div>
                        <div className="shift-details">
                          <div>
                            {_.isEmpty(
                              props.doctorData.shiftTime[0].startTime
                            ) ||
                            _.isEmpty(props.doctorData.shiftTime[0].endTime)
                              ? t("noShift")
                              : `${props.doctorData.shiftTime[0].startTime} - ${props.doctorData.shiftTime[0].endTime}`}
                          </div>
                        </div>
                      </div>
                      <div>
                        {!_.isEmpty(props.doctorData.templateAvailability) ? (
                          props.doctorData?.shiftTime?.length === 1 &&
                          componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                            <div className="not-oncall-div">
                              {!props.doctorData.onGoing &&
                                componentName ===
                                  CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                  <div>{t("notOnCall")}</div>
                                )}
                            </div>,
                            <div
                              className={`availability-div ${
                                _.isEmpty(props.doctorData.shiftTime) &&
                                "availability-div-no-shift"
                              }`}
                            >
                              {t("availableAt")} {" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.startTime
                              )}{" "}
                              --{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.endTime
                              )}
                            </div>,
                          ]
                        ) : (
                          <div className="availability-div-none"> -- </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="no-shift-speciality-details">{t("noShift")}</div>
                  ))}

                  {props.doctorData?.shiftTime?.length > 1
                    ? [
                        <div
                          id={`more-button-div-${props.doctorData.guid}`}
                          className="more-button-div align-more-button"
                        >
                          {componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && (
                            <IonButton
                              className={
                                hideMoreButton ? "hide-display" : "more-button"
                              }
                              onClick={() => {
                                showShiftData(true);
                                setHideMoreButton(true);
                                setHideLessButton(false);
                                doctorCardService.increaseDoctorCardHeight(
                                  props.doctorData
                                );
                              }}
                            >
                              {t("more")}
                            </IonButton>
                          )}
                        </div>,
                        <div className={hideMoreButton ? "hide-display" : ""}>
                          {!_.isEmpty(props.doctorData.templateAvailability) ? (
                            componentName !==
                              CONSTANTS.COMPONENTS.GROUP_SMS && [
                              <div className="not-oncall-div">
                                {!props.doctorData.onGoing &&
                                  componentName ===
                                    CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                    <div>{t("notOnCall")}</div>
                                  )}
                              </div>,
                              <div
                                className={`availability-div ${
                                  _.isEmpty(props.doctorData.shiftTime) &&
                                  "availability-div-no-shift"
                                }`}
                              >
                                {t("availableAt")} {" "}
                                {doctorCardService.availabilityTimeFormat(
                                  props.doctorData.templateAvailability!
                                    .startTime
                                )}{" "}
                                --{" "}
                                {doctorCardService.availabilityTimeFormat(
                                  props.doctorData.templateAvailability!.endTime
                                )}
                              </div>,
                            ]
                          ) : (
                            <div className="availability-div-none"> -- </div>
                          )}
                        </div>,
                        <div>
                          {checked
                            ? props.doctorData.shiftTime
                                .slice(1)
                                .map((item: ShiftTime, index: number) => {
                                  if (
                                    item.group.speciality ===
                                    props.doctorData.shiftTime[0].group
                                      .speciality
                                  ) {
                                    hideSpeciality = true;
                                  }
                                  return (
                                    <div>
                                      {hideSpeciality ? null : (
                                        <div className="speciality-details">
                                          <div>
                                            {doctorCardService.specialityTrim(
                                              item.group.speciality
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      <div className="shift-details shift-details-more">
                                        <div>
                                          {item.startTime} - {item.endTime}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            : null}
                          {checked
                            ? [
                                <div
                                  id={`less-button-div-${props.doctorData.guid}`}
                                  className="less-button-div"
                                >
                                  <IonButton
                                    className={
                                      hideLessButton
                                        ? "hide-display"
                                        : "less-button"
                                    }
                                    onClick={() => {
                                      showShiftData(false);
                                      setHideLessButton(true);
                                      setHideMoreButton(false);
                                      doctorCardService.decreaseDoctorCardHeight(
                                        props.doctorData
                                      );
                                    }}
                                  >
                                    {t("less")}
                                  </IonButton>
                                </div>,
                                <div>
                                  {!_.isEmpty(
                                    props.doctorData.templateAvailability
                                  ) ? (
                                    [
                                      <div className="not-oncall-div">
                                        {!props.doctorData.onGoing &&
                                          componentName ===
                                            CONSTANTS.COMPONENTS
                                              .ONCALL_LOOK_UP && (
                                            <div>{t("notOnCall")}</div>
                                          )}
                                      </div>,
                                      <div
                                        className={`availability-div ${
                                          _.isEmpty(
                                            props.doctorData.shiftTime
                                          ) && "availability-div-no-shift"
                                        }`}
                                      >
                                        {t("availableAt")} {" "}
                                        {doctorCardService.availabilityTimeFormat(
                                          props.doctorData.templateAvailability!
                                            .startTime
                                        )}{" "}
                                        --{" "}
                                        {doctorCardService.availabilityTimeFormat(
                                          props.doctorData.templateAvailability!
                                            .endTime
                                        )}
                                      </div>,
                                    ]
                                  ) : (
                                    <div className="availability-div-none">
                                      {" "}
                                      --{" "}
                                    </div>
                                  )}
                                </div>,
                              ]
                            : null}
                        </div>,
                      ]
                    : null}
                  {props.doctorData.providerAddedBy && (
                    <div>
                      <div>
                        Added By :
                        <span className="added-by-provider">
                          {props.doctorData.providerAddedBy}
                        </span>
                      </div>
                      <div className="add-provider-time-label">
                        <span
                          className={`provider-text-${props.doctorData.providerAlertStatus}`}
                        >
                          {props.doctorData.providerResponseTime}
                        </span>{" "}
                      </div>
                    </div>
                  )}
                  {props.isFromCareTeamCard && (
                    <div>
                      <div className="add-provider-time-label">
                        <span
                          className={`care-team-${props.doctorData.careTeamAlertStatus}`}
                        >
                          {props.doctorData.careTeamResponseTime}
                        </span>{" "}
                      </div>
                    </div>
                  )}
                </div>

                {!props.hideFeatureButtons && (
                  <>
                    <div className="doctor-icon-wrapper">
                      <div className="call-div ">
                        <Call selectedDoctorGuid={props.doctorData.guid}></Call>
                      </div>

                      {/* <div className="sms-div">
                        <Sms selectedDoctorGuid={props.doctorData.guid}></Sms>
                      </div> */}

                      {/* {props.rolePermissions.mediaShare &&
                        componentName !== CONSTANTS.COMPONENTS.FILE_SHARE && ( */}
                      <div className="file-attach-div">
                        <div
                          className=""
                          onClick={() => {
                            history.push({
                              pathname: "/client/messages",
                              state: {
                                selectedDoctorData: [props.doctorData],
                                mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
                                isFullscreen: true,
                                n2nNetwork:selectedNetwork?.value??''
                              },
                            });
                          }}
                          style={{
                            fontSize: "1.2rem",
                            color: "#098689",
                            width: "1.3rem",
                            height: "1.05rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          {" "}
                          <MessageIcon />
                        </div>
                        {/* <FileShare
                              selectedDoctorData={props.doctorData}
                            ></FileShare> */}
                      </div>
                      {/* )} */}
                      {props.doctorListInputDetails.isShowCloseIcon && (
                        <div
                          title={t("delete")}
                          className="close-icon-div"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            className="input-icon icon-close"
                            onClick={() => setIsShowAlert(true)}
                          ></div>
                        </div>
                      )}
                    </div>
                    <div hidden={props.isFromUserCard}>
                      <div
                        className="user-unlink-time icon-eta"
                        title={t("edit")}
                        hidden={!props.doctorData.canEditTime}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          editTimeSpanModal(props.doctorData);
                          setSelectedUserData(props.doctorData);
                        }}
                      >
                        {" "}
                      </div>
                      <div
                        className="icon-unlink user-unlink"
                        title={t("unlink")}
                        onClick={() => {
                          SetIsShowUnlinkAlert(true);
                          setItemToDelete(props.doctorData.guid);
                        }}
                        hidden={!props.doctorData.teamUnlink}
                      ></div>

                      <div
                        className={`status-icon-wrapper ${
                          props.doctorData.statusMessageAvailable
                            ? ""
                            : "disabled-icon"
                        }`}
                        onClick={() => {
                          setShowStatusMessage(true);
                          getUserStatusMessage(props.doctorData.guid,selectedNetwork);
                        }}
                        title={t("statusMessage")}
                      >
                        <IonIcon
                          className={`status-update ${
                            props.doctorData.statusMessageAvailable
                              ? ""
                              : "disabled-icon"
                          }`}
                          icon={chatboxEllipses}
                        ></IonIcon>
                      </div>

                      {props.isFromOnCallSearch && (
                        <div
                          className="teams-icon-wrapper"
                          onClick={viewTeammates}
                          title={t("teammates")}
                          hidden={props.isFromCareTeamCard}
                        >
                          <span
                            className="icon-team teams-icon"
                            hidden={!props.doctorData.teamsAvailable}
                          ></span>
                        </div>
                      )}
                      {!props.isFromCaseHistoryDetails &&
                        !props.caseDetailsPageProviderList && (
                          <div
                            className={`teams-icon-wrapper ${
                              props.isFromOnCallSearch
                                ? "hide-teammate-icon"
                                : ""
                            }`}
                            onClick={viewTeammates}
                            title={t("teammates")}
                            hidden={props.isFromCareTeamCard}
                          >
                            <span
                              className="icon-team teams-icon"
                              hidden={!props.doctorData.teamsAvailable}
                            ></span>
                          </div>
                        )}

                      {props.caseDetailsPageProviderList && (
                        <div
                          className={`teams-icon-wrapper ${
                            props.isCancelledOrCancelled
                              ? "disable-teammate-icon"
                              : ""
                          }`}
                          onClick={addTeammatesToProviders}
                        >
                          <span
                            className="icon-team teams-icon"
                            hidden={!props.doctorData.teamsAvailable}
                          ></span>
                        </div>
                      )}

                      {props.isFromCaseHistoryDetails && (
                        <div
                          className="teams-icon-wrapper"
                          onClick={viewTeammates}
                        >
                          <span
                            className="icon-team teams-icon"
                            hidden={!props.doctorData.teamsAvailable}
                          ></span>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        </IonCard>

        <IonAlert
          isOpen={isShowUnlinkAlert}
          onDidDismiss={() => {
            SetIsShowUnlinkAlert(false);
          }}
          cssClass="fav-delete-alert"
          header={t("confirmation")}
          message={t("unlinkUserConfirm")}
          buttons={[
            {
              text: t("no"),
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: t("ok"),
              handler: () => {
                unlinkUserFromTeam();
                SetIsShowUnlinkAlert(false);
              },
            },
          ]}
        />

        <IonAlert
          isOpen={isShowUnlinkProviderAlert}
          onDidDismiss={() => {
            SetIsShowUnlinkProviderAlert(false);
          }}
          cssClass="fav-delete-alert"
          header={t("confirmation")}
          message={t("removeProviderConfirm")}
          buttons={[
            {
              text: t("no"),
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: t("ok"),
              handler: () => {
                unlinkProviderFromCase();
                SetIsShowUnlinkProviderAlert(false);
              },
            },
          ]}
        />

        <TeamCreation
          showModal={editTimeModal}
          teamId={props.teamID}
          fromAccordionUserCard={true}
          updateTeamList={updatedTeamList}
          editUserTimeSpan={true}
          selectedTeamDetails={props.teamDetails}
          selectedUserData={selectedUserData}
          onOk={() => {
            enableEditTimeModal(false);
          }}
          onCancel={() => {
            enableEditTimeModal(false);
          }}
        ></TeamCreation>

        <TeammatesToProvider
          showModal={showTeammatesToProviderModal}
          doctorListDataFromParent={props.doctorData}
          onOk={() => {
            setTeammatesToProvider(false);
          }}
          onCancel={() => {
            setTeammatesToProvider(false);
          }}
          accordionList={otherUserList}
          patientID={props.patientDataID}
          patientData={props?.patientData}
          updateCaseDetailsPage={props.updateCaseDetailsPage}
          caseDetailsPageProviderList={props.caseDetailsPageProviderList}
          isCancelledOrCancelled={props.isCancelledOrCancelled}
        ></TeammatesToProvider>

        <IonModal
          isOpen={isShowModal}
          backdropDismiss={false}
          className="fm-teams-list-modal"
        >
          <div className="fm-team-list-modal-container">
            <div
              className="close-team-modal-icon"
              onClick={() => {
                setIsShowModal(false);
                if (props.updateTeamList) {
                  props.updateTeamList(true);
                }
              }}
            >
              <IonIcon icon={close} />
            </div>
            <TeamsPage
              fromSelectDropdown={false}
              isFromUserCard={true}
              selectedDoctorData={props.doctorData}
              isFromCaseHistoryDetails={props?.isFromCaseHistoryDetails}
              updateTeamList={updatedTeamList}
            ></TeamsPage>
          </div>
        </IonModal>
      </div>
    </>
  );
};

export default DoctorCard;

export const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 101 92"
      fill="none"
    >
      <path
        d="M90.0217 0H10.9783C8.06772 0.00347821 5.27738 1.15852 3.21931 3.21176C1.16124 5.265 0.00348638 8.0488 0 10.9525V59.1436C0.00348638 62.0473 1.16124 64.8311 3.21931 66.8844C5.27738 68.9376 8.06772 70.0927 10.9783 70.0961H15.3696V87.5216C15.361 88.4149 15.6223 89.29 16.1192 90.0331C16.6162 90.7762 17.3258 91.3528 18.1558 91.6879C18.9589 92.0111 19.841 92.0854 20.687 91.9009C21.533 91.7165 22.3037 91.282 22.8985 90.654L42.6549 70.0961H90.0217C92.9323 70.0927 95.7226 68.9376 97.7807 66.8844C99.8388 64.8311 100.997 62.0473 101 59.1436V10.9525C100.997 8.0488 99.8388 5.265 97.7807 3.21176C95.7226 1.15852 92.9323 0.00347821 90.0217 0ZM96.6087 59.1436C96.607 60.886 95.9124 62.5564 94.6775 63.7885C93.4426 65.0205 91.7682 65.7134 90.0217 65.7151H41.7174C41.4212 65.7151 41.1281 65.7749 40.8556 65.8908C40.5832 66.0068 40.3371 66.1765 40.1321 66.3898L19.7609 87.5216V67.9056C19.7609 67.3247 19.5295 66.7675 19.1178 66.3567C18.706 65.9459 18.1475 65.7151 17.5652 65.7151H10.9783C9.23183 65.7134 7.55742 65.0205 6.32251 63.7885C5.08759 62.5564 4.39305 60.886 4.3913 59.1436V10.9525C4.39305 9.21018 5.08759 7.5397 6.32251 6.30768C7.55742 5.07566 9.23183 4.38275 10.9783 4.38101H90.0217C91.7682 4.38275 93.4426 5.07566 94.6775 6.30768C95.9124 7.5397 96.607 9.21018 96.6087 10.9525V59.1436ZM65.167 16.9874C64.7689 16.3725 64.2227 15.8669 63.5783 15.5169C62.934 15.1668 62.212 14.9834 61.4783 14.9834C60.7446 14.9834 60.0226 15.1668 59.3782 15.5169C58.7338 15.8669 58.1877 16.3725 57.7896 16.9874L45.327 36.2003L38.6435 27.3068C38.2199 26.7844 37.6846 26.3631 37.0768 26.0737C36.4689 25.7843 35.8039 25.6341 35.1304 25.6341C34.4569 25.6341 33.7919 25.7843 33.1841 26.0737C32.5763 26.3631 32.041 26.7844 31.6174 27.3068L16.2478 47.753C15.7585 48.4039 15.4605 49.1778 15.3873 49.9882C15.3141 50.7985 15.4685 51.6131 15.8332 52.3409C16.1979 53.0686 16.7585 53.6806 17.4522 54.1083C18.1459 54.5361 18.9454 54.7626 19.7609 54.7626H81.5948C82.3843 54.7624 83.1592 54.5499 83.8379 54.1474C84.5165 53.7449 85.0738 53.1672 85.4512 52.4754C85.8285 51.7835 86.0119 51.0029 85.982 50.2158C85.9521 49.4287 85.71 48.6642 85.2813 48.0027L65.167 16.9874ZM19.7609 50.3816L35.1304 29.9354L43.7045 41.3414C43.9067 41.6345 44.1824 41.8696 44.5041 42.0233C44.8257 42.177 45.1821 42.244 45.5378 42.2176C45.8916 42.2056 46.2371 42.1082 46.5449 41.9339C46.8528 41.7595 47.1137 41.5134 47.3053 41.2165L61.4783 19.3662L81.5948 50.3816H19.7609Z"
        fill="#098689"
      />
    </svg>
  );
};
